import React, { useRef, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import useStyles from "./styles";

export interface Props {
  label?: string;
  value: string;
  onSave?: (value: string) => void;
  onChange?: (value: string) => void;
  onCancel?: () => void;
  savedValue?: string;
  maxLength?: number;
  expandedProps?: {
    label?: string;
  };
}

const ExpandableTextarea = (props: Props) => {
  const {
    label,
    maxLength,
    onSave,
    onCancel,
    onChange,
    expandedProps,
    value,
    savedValue = ""
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);
  const classes = useStyles();

  const [focus, setFocus] = useState<boolean>(false);
  const expanded = value.length || focus;

  const handleChange = event => {
    onChange?.(event.currentTarget.value);
  };

  const handleCommentFocus = () => {
    setFocus(true);
  };

  const handleCommentBlur = () => {
    setFocus(false);
  };

  const handleSaveClick = () => {
    onSave && onSave(value);
  };

  const handleCancelClick = () => {
    onCancel?.();
  };

  return (
    <div className={classes.root}>
      <div className={classes.textareaWrapper}>
        <TextField
          label={
            expanded && expandedProps?.label ? expandedProps?.label : label
          }
          value={value}
          onChange={handleChange}
          variant={"outlined"}
          size={"small"}
          classes={{
            root: classes.textareaRoot
          }}
          InputProps={{
            classes: {
              root: classes.inputRoot,
              focused: classes.inputFocused,
              notchedOutline: classes.inputNotchedOutline
            }
          }}
          InputLabelProps={{
            classes: {
              root: classes.inputLabelRoot,
              shrink: classes.inputLabelShrink,
              focused: classes.inputLabelFocused
            }
          }}
          inputProps={{
            maxLength: 200
          }}
          minRows={expanded ? 4 : 1}
          multiline
          onFocus={handleCommentFocus}
          onBlur={handleCommentBlur}
          inputRef={inputRef}
        />
        {maxLength && (
          <div className={classes.counter}>
            {value.length}&nbsp;/&nbsp;{maxLength}
          </div>
        )}
      </div>
      {expanded && (
        <div className={classes.buttons}>
          <Button onClick={handleCancelClick}>Cancel</Button>
          <Button
            className={classes.saveButton}
            onClick={handleSaveClick}
            disabled={savedValue === value || !value.length}
          >
            Save
          </Button>
        </div>
      )}
    </div>
  );
};

export default ExpandableTextarea;
